// This file is for generic constants (which may not belong to any group)

export const generalConstants = {
  cost_to_ship: "59",
  algolia_plp_hitcount_desktop: 102,
  algolia_plp_hitcount_tablet: 100,
  algolia_plp_hitcount_mobile: 100,
  builder_plp_content_tile1_position: 6,
  builder_plp_content_tile2_position: 20,
  valid_plp_slug: [
    "women",
    "jewelry-watches",
    "beauty",
    "home-gifts",
    "new-arrivals",
    "register",
    "login",
    "account",
    "collection",
    "superbrands-ui",
    "designer",
    "sale",
    "activate-account"

  ],
  show_style_heels: ["shoes", "Shoes"],
  show_style_sleeves_and_pattern: ["clothing", "Clothing"],
  show_material_filter: ["jewelry-watches", "Jewelry & watches"],
  show_available_filter: ["jewelry-watches", "Jewelry & watches","clothing", "Clothing","new-arrivals"],
  sitemap_index: ["SitemapProductList1.xml","SitemapBasic.xml","SitemapCatalog.xml"],
  gift_card_type: ['Gift Cards'],
  size_weights: {
    XXS: 1,
    XS: 2,
    S: 3,
    M: 4,
    L:5,
    XL: 6,
    XXL: 7,
    "XS/S":8,
    "M/L":9
  }, 
  gift_card_option_name: "Denominations",
  product_type_donation_tag: "donation_product",
  user_discount_tag: "rewards",
  //user_discount_tag2: "fall25code",
  migrated_customer_flag: ["DISABLED","INVITED"],
  migrated_customer_invited_status: "INVITED",
  migrated_customer_date: "2022-10-03",
  one_size: "one size",
  help_email: "help@olivela.com",
  personal_shopper_email: "personalshopper@olivela.com",
  yotpo_tier_images: {
    "bronze":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-one.png`, 
    "level 1":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-one.png`, 
    "level one":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-one.png`, 
    "tier one":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-one.png`, 
    "silver":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-two.png`, 
    "level 2":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-two.png`,
    "tier two":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-two.png`,
    "level two":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-two.png`,
    "gold":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-three.png`,
    "level 3":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-three.png`,
    "tier three":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-three.png`,
    "level three":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-tier-three.png`,
  },
  yotpo_hero_images: {
    desktop : {
      "bronze":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-one.png`, 
      "level 1":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-one.png`, 
      "level one":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-one.png`, 
      "tier one":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-one.png`, 
      "silver":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-two.png`, 
      "level 2":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-two.png`,
      "tier two":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-two.png`,
      "level two":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-two.png`,
      "gold":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-three.png`,
      "level 3":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-three.png`,
      "tier three":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-three.png`,
      "level three":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-three.png`,
    },
    mobile : {
      "bronze":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-one-mobile.png`, 
      "level 1":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-one-mobile.png`, 
      "level one":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-one-mobile.png`, 
      "tier one":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-one-mobile.png`, 
      "silver":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-two-mobile.png`, 
      "level 2":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-two-mobile.png`,
      "tier two":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-two-mobile.png`,
      "level two":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-two-mobile.png`,
      "gold":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-three-mobile.png`,
      "level 3":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-three-mobile.png`,
      "tier three":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-three-mobile.png`,
      "level three":`${process.env.NETLIFY_URL}/images/Yotpo/yotpo-hero-tier-three-mobile.png`,
    }
    
  },
  // yotpo tier names with level points.
  yotpo_tier_names:{
    "bronze":1, 
    "level 1":1, 
    "level one":1, 
    "tier one":1, 
    "silver":2, 
    "level 2":2,
    "tier two":2,
    "level two":2,
    "gold":3,
    "level 3":3,
    "tier three":3,
    "level three":3
  }
  ,
  yotpo_tier_base_points: {
    "bronze":1, 
    "level 1":1, 
    "level one":1, 
    "tier one":1, 
    "silver":1.25, 
    "level 2":1.25,
    "tier two":1.25,
    "level two":1.25,
    "gold":1.50,
    "level 3":1.50,
    "tier three":1.50,
    "level three":1.50,
  },
  yotpo_default_tier: "level 1",
  yotpo_doller_image:`${process.env.NETLIFY_URL}/images/Yotpo/generic_rewards.png`,
  yotpo_doller_image_one:`${process.env.NETLIFY_URL}/images/Yotpo/generic_rewards_one.png`,
  yotpo_doller_image_two:`${process.env.NETLIFY_URL}/images/Yotpo/generic_rewards_two.png`,
  yotpo_doller_image_three:`${process.env.NETLIFY_URL}/images/Yotpo/generic_rewards_three.png`,
  yotpo_default_header_image:`${process.env.NETLIFY_URL}/images/Yotpo/loyalty_hero_image.png`,
  yotpo_default_header_image_mobile: `${process.env.NETLIFY_URL}/images/Yotpo/loyalty_hero_image_mobile.png`,
  yotpo_promo_signedin_desktop: `${process.env.NETLIFY_URL}/images/Yotpo/signedin-promo-desktop.jpg`,
  yotpo_promo_signedin_tablet: `${process.env.NETLIFY_URL}/images/Yotpo/signedin-promo-tablet.jpg`,
  yotpo_promo_signedin_mobile: `${process.env.NETLIFY_URL}/images/Yotpo/signedin-promo-mobile.jpg`,
  yotpo_promo_signedout_desktop: `${process.env.NETLIFY_URL}/images/Yotpo/not-signedin-promo-desktop.jpg`,
  yotpo_promo_signedout_tablet: `${process.env.NETLIFY_URL}/images/Yotpo/not-signedin-promo-tablet.jpg`,
  yotpo_promo_signedout_mobile : `${process.env.NETLIFY_URL}/images/Yotpo/not-signedin-promo-mobile.jpg`,

  plp_static_links:[
    {
      "url": `${process.env.NETLIFY_URL}/new-arrivals`,
      "changefreq": 'daily',
      "priority": 0.8
    },
    {
      "url": `${process.env.NETLIFY_URL}/sale`,
      "changefreq": 'daily',
      "priority": 0.8
    },
    {
      "url": `${process.env.NETLIFY_URL}/women`,
      "changefreq": 'daily',
      "priority": 0.8
    }
  ],
  order_status:{
    "DEFAULT":"Processing",
    "UNFULFILLED_PAID":"Processing",
    "UNFULFILLED_PARTIALLY_REFUNDED":"Partially refunded",
    "UNFULFILLED_PARTIALLY_PAID":"Processing",
    "UNFULFILLED_REFUNDED":"Refunded",
    "FULFILLED_PAID":"Shipped",
    "FULFILLED_PARTIALLY_REFUNDED":"Partially refunded",
    "FULFILLED_REFUNDED":"Refunded",
    "PARTIALLY_FULFILLED_PARTIALLY_PAID":"Partially shipped",
    "PARTIALLY_FULFILLED_PAID":"Partially shipped",
    "PARTIALLY_FULFILLED_PARTIALLY_REFUNDED":"Partially refunded",
    "CANCELLED":"Canceled",
  },
  min_variant_quantity : 1,
  special_event_flag: true,
  special_event_color: "#08A696",
  special_event_txt_color: "#ffffff",
  special_event_start_date: 'Nov 1',
  special_event_end_date: 'Dec 24',
  christas_cutoff_start_date: 'Dec 16',
  christas_cutoff_end_date: 'Dec 24',
  pre_order_tag: "Availability:Pre-order",
  pre_order: "Pre-order",
  available_now: "Available now",
  available_now_tag: "Availability:Available now",
  RAKUTEN_INDIVIDUAL_ITEM_TOKEN : "ZW5jcnlwdGVkYToyOntzOjU6IlRva2VuIjtzOjI0OiJ3VXBadHg1OFZQb20yNGRDREIxTFdRPT0iO3M6ODoiVXNlclR5cGUiO3M6MTA6IkFkdmVydGlzZXIiO30%3D",
  RAKUTEN_GROSS_REVENUE_TOKEN : "ZW5jcnlwdGVkYToyOntzOjU6IlRva2VuIjtzOjI0OiJ3VXBadHg1OFZQb20yNGRDREIxTFdRPT0iO3M6ODoiVXNlclR5cGUiO3M6MTA6IkFkdmVydGlzZXIiO30%3D",
  gift_card_handle: "gift-card",
  designer_cause_association : {
    "hellessy" : "cancercartel",
    "nantucket-mini-beach-tote-bag-pink-gold":"wfwi",
    "palm-beach-medium-tote-bag-natural-navy":"wfwi",
    "nantucket-medium-beach-tote-bag-navy-white":"wfwi",
    "laren-wide-leg-pants-paprika-candy-pink":"wfwi",
    "mini-beach-tote-sky-latte":"wfwi",
    "lona-shirt-paprika-candy-pink":"wfwi",
    "nako-flat-sandal-paprika-candy-pink-mix":"wfwi",
    "lona-shirt-paprika-sky":"wfwi",
    "reka-espadrille-flat-paprika-natural":"wfwi",
    "beach-basket-tote-bag-natural-paprika-light-gold":"wfwi",
    "laren-wide-leg-pants-paprika-sky":"wfwi",
    "reta-silk-scarf-paprika-candy-pink":"wfwi",
    "nako-flat-sandal-sky-sky-mix":"wfwi",
    "ricia-95-platform-sandal-latte-natural":"wfwi",
    "avenue-pouch-natural-latte":"wfwi",
    "small-bon-bon-bucket-bag-natural-paprika-candy-pink-mix-light-gold":"wfwi",
    "bon-bon-fringe-bucket-bag-natural-candy-pink-mix-light-gold":"wfwi",
    "ricia-95-platform-sandal-candy-pink-natural":"wfwi",
    "diamond-top-handle-bag-natural-candy-pink-gold":"wfwi",
    "reta-silk-scarf-paprika-sky":"wfwi",
    "alizze-kb-85-black":"wfwi",
    "amel-50-macaron-crystal":"wfwi",
    "lexy-0jc5002bu-e93-light-brown":"wfwi",
    "saeda-100-sunset-mix-crystal":"wfwi",
    "ixia-95-latte":"wfwi",
    "bon-bon-bckt-e-w-sm-rose-antique-silver":"wfwi",
    "amel-50-biscuit":"wfwi",
    "verona-ballet-pink-crystal":"wfwi",
    "romy-60-black":"wfwi",
    "bon-bon-bckt-e-w-latte-gold":"wfwi",
    "lorea-0jc5001b-e13-gradient-brown":"wfwi",
    "bon-bon-pink-mix":"wfwi",
    "bing-100-pink-mix":"wfwi",
    "verona-black":"wfwi",
    "diamond-tophandle-black-gold":"wfwi",
    "romy-85-rose":"wfwi",
    "lorea-0jc5001b-e8g-gradient-grey":"wfwi",
    "gal-130-wedge-natural-ecru":"wfwi",
    "diamond-tilda-loafer-black":"wfwi",
    "romy-60-rattan":"wfwi",
    "bon-bon-bckt-e-w-black-antique-silver":"wfwi",
    "addie-pearl-black":"wfwi",
    "amel-50-black":"wfwi",
    "lexy-0jc5002bu-e81-dark-grey-polar":"wfwi",
    "lorea-0jc5001b2-e13-gradient-brown-2":"wfwi",
    "bon-bon-bckt-e-w-sm-latte-gold":"wfwi",
    "diamond-tilda-flat-black":"wfwi",
    "alizze-kb-85-taupe":"wfwi",
    "bing-100-macaron-mix":"wfwi",
    "diamond-tophandle-taupe-gold":"wfwi",
    "ixia-95-black":"wfwi",
    "bon-bon-bckt-e-w-sm-black-antique-silver":"wfwi",
    "nari-flat-black-anthracite":"wfwi",
    "cycas-ab-50-black":"wfwi",
    "pandora-jacquard-midi-dress-malachite":"d4s",
    "satin-bias-cap-sleeve-maxi-dress-olive": "wef",
    "wool-twill-two-button-blazer-olive": "wef",
    "pinstripe-stretch-wool-sleeveless-vest-midi-dress-navy-pinstripe": "wef",
    "wool-cashmere-shrunken-crewneck-sweater-olive": "wef",
    "seasonless-wool-double-breasted-chelsea-blazer-taupe": "wef",
    "seasonless-wool-single-pleat-wide-leg-trousers-taupe": "wef",
    "satin-bias-cap-sleeve-maxi-dress-black": "wef",
    "wool-twill-tailored-midi-dress-black": "wef",
    "seasonless-wool-double-breasted-blazer-black": "wef",
    "seasonless-wool-wide-leg-trousers-black": "wef",
    "seasonless-wool-shallow-v-neck-waistcoat-black": "wef",
    "seasonless-wool-single-button-blazer-black": "wef",
    "woven-satin-short-sleeve-top-taupe": "wef",
    "satin-bias-high-rise-midi-skirt-taupe": "wef",
    "tailored-twill-cap-sleeve-mini-dress-black": "wef",
    "satin-bias-long-sleeve-crewneck-top-black": "wef",
    "satin-bias-high-rise-midi-skirt-black": "wef",
    "wool-cashmere-polo-sweater-cream": "wef",
    "seasonless-wool-tailored-slim-ankle-trousers-black": "wef",
    "stretch-wool-slim-knit-turtleneck-black": "wef",
    "wool-cashmere-polo-sweater-navy": "wef",
    "stretch-tencel-knit-long-sleeve-crewneck-sweater-ochre": "wef",
  },
  kustomer_brand_id: "663a5f779284198e08f693e5",
  kustomer_api_key: "eyJhbGciOiJub25lIn0.eyJvcmciOiI2NjNhNWY3NDkyODQxOThhZDZmNjkzMGQiLCJvcmdOYW1lIjoib2xpdmVsYSIsInJvbGVzIjpbIm9yZy50cmFja2luZyJdfQ.",
  engraving_metal_color : {
    "stainless_steel":`${process.env.NETLIFY_URL}/images/MetallicColors/Steel.png`,
    "WhiteGold":`${process.env.NETLIFY_URL}/images/MetallicColors/White.png`,
    "YellowGold":`${process.env.NETLIFY_URL}/images/MetallicColors/Gold.png`,
    "RoseGold":`${process.env.NETLIFY_URL}/images/MetallicColors/RoseGold.png`
  },
  // Yotpo instance IDS
  YOTPO_BANNER_INSTANCE_ID: process.env.APP_MODE == 'production' ? '881685' : "865825",
  YOTPO_MY_ACTIVITY_INSTANCE_ID: process.env.APP_MODE == 'production' ? '881692' : "865831",
  YOTPO_EARNING_POINTS_INSTANCE_ID: process.env.APP_MODE == 'production' ? '881690' : "865827",
  YOTPO_VIP_TIERS_INSTANCE_ID: process.env.APP_MODE == 'production' ? '881686' :  "865824",
  RECOMMENDATION_THRESHOLD: 800,
};

